import { useCart } from '../../hooks/useCart'
import { Container } from './styles'
import { ReactComponent as CartIcon } from '../../assets/shopping-cart.svg'

export function MyOrder() {
  const { cart } = useCart()
  const quantityCart = cart.reduce((acc, item) => acc + item.quantity, 0)
  return (
    <Container to='/cart'>
      <span>Meu Pedido</span>
      <CartIcon />
      {cart.length !== 0 && <span>{`${quantityCart}`.padStart(2, '0')}</span>}
    </Container>
  )
}
